import { TokenListField, TokenListFieldProps } from '@components/token-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormTokenListFieldProps<T = unknown> = FormFieldProps<TokenListFieldProps, T>;

export function FormTokenListField<T>(props: FormTokenListFieldProps<T>) {
  const formFieldProps = useFormField({ ...props });

  return <TokenListField {...props} {...formFieldProps} />;
}
